<template>
    <button ref="btn"
        class="el-btn"
        :type="type"
        :disabled="disabled"
        :title="title"
        :aria-label="ariaLabel"
        @click="$emit('click', $event)">
        <slot name="before"></slot>
        <i v-if="icon" :class="[icon ? `lnr-${icon}` : '']"></i>
        <span class="o-ol" v-if="!lblEntity && lbl" :class="lblClassNames">
            {{ lbl | athT(lblParams) }}{{ this.count || this.count === 0 ? (' (' + count + ')') : '' }}
        </span>
        <span class="o-ol" v-if="lblEntity" :class="lblClassNames">
            {{ lbl | athTEnt(lblEntity, lblEntityLc) }}{{ this.count || this.count === 0 ? (' (' + count + ')') : '' }}
        </span>
        <i v-if="iconRight" :class="[iconRight ? `lnr-${iconRight}` : '']"></i>
        <slot name="after"></slot>
    </button>
</template>

<script>
import { isNeString, isNumber } from '@aretheyhappy/utils';

export default {
    name: 'mead-button',
    props: {
        /**
         * The translation key for the button's label text, run through the `athT`
         * filter. Set to `false` to render no text label (e.g. an icon-only button).
         */
        lbl         : {type: [String, Boolean], default: () => false},
        /**
         * Interpolation params passed to the `athT` filter alongside `lbl`.
         */
        lblParams   : {type: Object, default: () => ({})},
        /**
         * Entity type used to look up an entity-specific translation for `lbl`
         * (via the `athTEnt` filter) instead of a plain translation key.
         */
        lblEntity   : {type: [Boolean, String], default: () => false},
        /**
         * Whether the entity-specific label produced via `lblEntity` should be
         * lowercased.
         */
        lblEntityLc : {type: Boolean, default: () => true},
        /**
         * Additional class name(s) applied to the label `<span>`.
         */
        lblClassNames: {type: String, default: ''},
        /**
         * The native HTML `type` attribute for the underlying `<button>` element.
         */
        type        : {type: String, default: () => 'button'},
        /**
         * Name of an icon (rendered via `lnr-{icon}`) shown before the label.
         */
        icon        : {type: [String, Boolean], default: () => false},
        /**
         * Name of an icon (rendered via `lnr-{iconRight}`) shown after the label.
         */
        iconRight   : {type: [String, Boolean], default: () => false},
        /**
         * Disables the button, preventing clicks and applying the disabled styling.
         */
        disabled    : {type: Boolean, default: () => false},
        /**
         * Explicit tooltip/aria-label text. When falsy, an aria-label is derived
         * automatically from `lbl`/`lblEntity` and `count`.
         */
        title       : {type: [String, Boolean], default: () => false},
        /**
         * Optional numeric count appended to the label (and aria-label) in the
         * form "Label (count)". Accepts `false` to omit it entirely.
         */
        count       : {type: [Number, Boolean], default: () => false},
        /**
         * When true, the button automatically receives focus once mounted.
         */
        uiAutoFocus : {type: Boolean, default: () => false},
    },
    computed: {
        ariaLabel: function () {
            if (isNeString(this.title)) return this.title;
            else if (!this.lblEntity && this.lbl)
                return `${MeadCommon.I18N.go(this.lbl, this.lblParams)}${isNumber(this.count) ?
                    (' (' + this.count + ')') : ''}`;
            else if (this.lblEntity)
                return `${MeadCommon.I18N.action(this.lblEntity, this.lblEntityLc)}${isNumber(this.count) ?
                    (' (' + this.count + ')') : ''}`;
            return '';
        }
    },
    mounted () {
        //  UIAutoFocus
        if (this.$refs.btn && this.uiAutoFocus) this.$refs.btn.focus();
    },
};
</script>